export default __webpack_public_path__ + "static/media/logoFarsijoo.f4217d01.png";